module.exports = "/_next/static/images/f06484dedec35f228c13e27371838c49-custom-pencil.svg";